import { useEffect, useState } from "react";
import { LuMessageCircle, LuSmartphone } from "react-icons/lu";
import QuoteStepHeading from "../../../../shared/components/QuoteStepHeading";
import ContactOptionCard from "../../components/ContactOptionCard";
import PortalBackButton from "../../components/PortalBackButton";
import PageContentStack from "../../../../shared/components/PageContentStack";

const ContactPage = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const updateMobileState = () => setIsMobile(window.innerWidth < 768);
    updateMobileState();
    window.addEventListener("resize", updateMobileState);
    return () => window.removeEventListener("resize", updateMobileState);
  }, []);

  const openWhatsApp = () =>
    window.open("https://wa.me/447802416568", isMobile ? "_self" : "_blank");

  const openSms = () => window.open("sms:+447455715794", "_self");

  return (
    <PageContentStack>
      <div className="tw-mt-3">
        <QuoteStepHeading
          title="Get in touch with our team"
          className="tw-mt-0"
          titleClassName="tw-m-0"
        />
      </div>

      <div className="tw-flex tw-flex-col tw-gap-4">
        <ContactOptionCard
          title="WhatsApp"
          description="Speak to an expert from your phone via WhatsApp."
          buttonLabel="Open WhatsApp"
          icon={
            <LuMessageCircle
              className="tw-h-7 tw-w-7"
              strokeWidth={2.3}
              aria-hidden="true"
            />
          }
          onClick={openWhatsApp}
        />
        <ContactOptionCard
          title="SMS"
          description={
            <>
              Send a text message to <strong>+44 7455 715794</strong> and our
              team will be in touch.
            </>
          }
          buttonLabel="Send a text"
          icon={
            <LuSmartphone
              className="tw-h-7 tw-w-7"
              strokeWidth={2.3}
              aria-hidden="true"
            />
          }
          onClick={openSms}
          disabled={!isMobile}
        />
      </div>
      <PortalBackButton />
    </PageContentStack>
  );
};

export default ContactPage;
